<template>
    <div class="chat-gpt">
        <GptMenu ref="gptMenu" @change="changeMenu" />
        <ChatWin :info="info" @renovateMenu="renovateMenu" />
    </div>
</template>

<script>
import ChatWin from './com/chatWin.vue';
import GptMenu from './com/gptMenu.vue';

export default {
    name: "chatGpt",
    components: { GptMenu, ChatWin },
    data() {
        return {
            info: {}
        }
    },
    methods: {
        renovateMenu() {
            this.$refs.gptMenu.getData();
        },
        changeMenu(item) {
            this.info = item;
        }
    },
}
</script>


<style lang="scss" >
.chat-gpt {
    height: 100%;
    display: flex;

    pre {
        width: 100%;
        white-space: pre-wrap;
    }

    .tip {
        text-align: center;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .title {
            font-size: 24px;
            font-weight: bold;
            padding-bottom: 20px;
        }

        .label {
            color: #666;
        }
    }

    .c-left {
        background: #222;
        width: 240px;
        flex-shrink: 0;
        color: #fff;
        display: flex;
        flex-direction: column;
        font-size: 14px;

        .list {
            height: 100%;
            overflow-y: auto;

            .list-item {
                padding: 15px 3px 15px 15px;
                background: #2a2a2a;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                white-space: nowrap;

                .title-bl {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    overflow: hidden;

                    i {
                        margin-right: 5px;
                    }

                    .title {}
                }

                &.active {
                    background: #333;
                }

                .btn-g {
                    visibility: hidden;

                    i {
                        padding: 0 8px;

                        &:hover {
                            color: #42b883;
                        }
                    }
                }

                &:hover .btn-g {
                    visibility: visible;
                }

            }
        }

        .del-btn,
        .add-btn {
            padding: 15px 15px;
            cursor: pointer;
        }

        .add-btn {
            border-bottom: 1px solid #444;
        }

        .del-btn {
            border-top: 1px solid #444;
        }
    }

    .c-right {
        height: 100%;
        display: flex;
        flex: 1;
        flex-direction: column;

        .pic-item {
            img {
                max-width: 500px;
            }
        }

        .chart-content {
            height: 100%;
            line-height: 2em;
            overflow-y: auto;

            .chart-item {
                padding: 15px 100px;
                display: flex;
                margin-bottom: 5px;

                &.is-they {
                    background: #f5f5f5;
                }

                .text {
                    flex: 1;
                    position: relative;

                    .el-button {
                        position: absolute;
                        right: 0;
                        top: -18px;
                        visibility: hidden;
                    }

                    &:hover .el-button {
                        visibility: visible;
                    }
                }

                .icon {
                    width: 50px;
                    height: 50px;
                    margin-right: 15px;
                    display: flex;
                    justify-content: center;
                    font-size: 13px;
                    align-items: center;
                    color: #fff;
                    flex-shrink: 0;
                    background: green;
                    border-radius: 5px;

                    &.icon-pic {
                        background: url("@/assets/images/logo.jpg") center center #fff;
                        background-size: 90%;
                    }
                }
            }

        }

        .footer {
            padding: 10px 100px;

            .tool {
                text-align: center;
            }

            .el-input__icon {
                cursor: pointer;
                font-size: 20px;
            }

            .tab {
                font-size: 12px;
                line-height: 30px;
                display: flex;
                align-items: center;

                .tab-item {
                    margin-right: 20px;
                    color: #999;
                    cursor: pointer;

                    &.active {
                        color: #333;
                        font-weight: bold;
                    }
                }
                .right{
                    flex: 1;
                    padding-left: 15px;
                    float: right;
                    display: flex;
                    width: 100px;
                    align-items: center;
                    .size{
                        padding-right: 10px;
                    }
                    .el-progress{
                        flex: 1;
                    } 
                }
            }
        }
    }

    .show-btn {
        display: none;
    }


    @media (max-width: 900px) {
        .show-btn {
            position: absolute;
            right: -22px;
            top: 50%;
            margin-top: -50px;
            border-radius: 0 5px 5px 0;
            height: 50px;
            width: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #ccc;
            background: #ffffff66;
            color: #222;
        }

        .c-left {
            position: absolute;
            left: -242px;
            z-index: 10;
            height: 100%;
            transition: all .2s;

            &.show {
                left: 0;
            }

            .list .list-item .btn-g {
                visibility: visible;
            }
        }

        .c-right {
            .pic-item {
                img {
                    max-width: 100%;
                }
            }

            .chart-content .chart-item,
            .footer {
                padding: 10px 15px;
            }

            .chart-content .chart-item .text .el-button {
                visibility: visible;
                top: -15px;
            }
        }

    }
}
</style>